import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UserDialogModel } from '@app/components';
import { PresenterType } from '@shared/components/presenter/presenter-type';


@PresenterType({
  model: UserDialogModel,
  key: 'title'
})

@Component({
  selector: 'user-dialog-header',
  standalone: false,
  templateUrl: './user-dialog-header.component.html',
  styleUrl: './user-dialog-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserDialogHeaderComponent {

}
